import TheGrid from '@/views/campaigns/bestof/objectives/grid'
import Edit from '@/views/campaigns/bestof/objectives/edit'

export default {
  path: '/campaigns/bestof/objectives',
  redirect: '/campaigns/bestof/objectives/index',
  name: 'bestof_objectives',
  meta: {
    auth: {
      redirect: {
        name: 'bestof_objectives.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Bestof'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'bestof_objectives.index',
    component: TheGrid,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'bestof_objectives.create',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'bestof_objectives.edit',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Editar'
    }
  }]
}
